<template>
  <div v-if="open" class="subscribe-success">
    <div class="subscribe-success__backdrop" @click="$emit('close')"></div>
    <div ref="modalEl" class="subscribe-success__modal" role="dialog" aria-modal="true" aria-labelledby="subscribe-success-title" @keydown.esc="$emit('close')">
      <button ref="closeButton" class="subscribe-success__close" type="button" @click="$emit('close')" :aria-label="t('closeLabel')">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
          <path d="M3.07617 3.07617C3.33853 2.81381 3.76266 2.81381 4.02502 3.07617L7.99992 7.05107L11.9748 3.07617C12.2372 2.81381 12.6613 2.81381 12.9237 3.07617C13.186 3.33853 13.186 3.76266 12.9237 4.02502L8.94877 7.99992L12.9237 11.9748C13.186 12.2372 13.186 12.6613 12.9237 12.9237C12.6613 13.186 12.2372 13.186 11.9748 12.9237L7.99992 8.94877L4.02502 12.9237C3.76266 13.186 3.33853 13.186 3.07617 12.9237C2.81381 12.6613 2.81381 12.2372 3.07617 11.9748L7.05107 7.99992L3.07617 4.02502C2.81381 3.76266 2.81381 3.33853 3.07617 3.07617Z" fill="#2A2C2C"></path>
        </svg>
      </button>
      <img :src="Image" alt="Картинка успішно сформованої підписки">
      <div class="subscribe-success__content">
        <h2 id="subscribe-success-title" class="subscribe-success__title h5" v-html="actionType === 'update' ? t('hasSubscriptionTitle') : t('title')"></h2>
        <p class="subscribe-success__text" v-html="actionType === 'update' ? t('hasSubscriptionText') : t('text')"></p>
      </div>
      <a :href="buttonLink" class="btn btn--dark" >
        {{ t('buttonLabel') }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, ref, watch } from 'vue';
import { createModalA11y } from '@/js/utils/modal-a11y';
import Image from './../../account/images/image-success.png';
const i18n = {
  uk: { 
    title: 'Твоя підписка на стіки <span class="block">успішно сформована</span>',
    hasSubscriptionTitle: 'Підписку успішно змінено',
    text: 'Деталі послуги Підписки доступні <span class="block">в Особистому кабінеті</span>',
    hasSubscriptionText: '<span class="block">Зміни буде застосовано</span> до наступного замовлення.',
    buttonLabel: 'ПОДИВИТИСЯ ДЕТАЛІ',
    closeLabel: 'Закрити'
  },
  ru: { 
    title: 'Ваша подписка на стики <span class="block">успешно сформирована</span>',
    hasSubscriptionTitle: 'Подписка успешно изменена',
    text: 'Детали услуги Подписки доступны <span class="block">в Личном кабинете</span>',
    hasSubscriptionText: '<span class="block">Изменения будут применены</span> к следующему заказу.',
    buttonLabel: 'ПОСМОТРЕТЬ ДЕТАЛИ',
    closeLabel: 'Закрыть'
  },
}
const locale = computed(() => window.Shopify?.locale || 'uk')
const t = (key) => i18n[locale.value]?.[key] || key;

const props = defineProps({
  open: Boolean,
  actionType: {
    type: String,
    default: 'create'
  }
})

const closeButton = ref(null);
const modalEl = ref(null);
let modalA11y = null;

watch(
  () => props.open,
  async (isOpen) => {
    if (!isOpen) {
      modalA11y?.deactivate();
      modalA11y = null;
      return;
    }

    await nextTick();

    modalA11y = createModalA11y(modalEl.value, {
      initialFocus: () => closeButton.value || modalEl.value,
      excludeInertTargets: (target) => target.classList?.contains('subscribe-success__backdrop'),
    });
    modalA11y?.activate();
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  modalA11y?.deactivate();
  modalA11y = null;
});

const buttonLink = computed(() =>
  locale.value === 'ru' ? '/ru/account#subscription:my-subscription' : '/account#subscription:my-subscription'
);

defineEmits(['close']);

</script>
